import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { H4 } from "components/Typography/text.styled";
import { SettingsSection } from "./settingSection.component";
import { NumberSettingInput } from "./numberSettingInput.component";

export const TimeReportStampTreshHoldSettings: React.FC<{
  beforeStartValue: number;
  onChangeBeforeStart: (v: number) => void;
  afterStartValue: number;
  onChangeAfterStart: (v: number) => void;
  beforeEndValue: number;
  onChangeBeforeEnd: (v: number) => void;
  afterEndValue: number;
  onChangeAfterEnd: (v: number) => void;
}> = (props) => {
  const { t } = useTranslation();

  return (
    <SettingsSection
      title={t("System.TimeReportStampTreshHold")}
      info={t("System.TimeReportStampTreshHoldInfo")}
    >
      <GroupContainer>
        <H4>{t("System.StampIn")}</H4>
        <InputsGrid>
          <NumberSettingInput
            label={t("System.BeforeStart")}
            value={props.beforeStartValue}
            onChange={props.onChangeBeforeStart}
          />
          <NumberSettingInput
            label={t("System.AfterStart")}
            value={props.afterStartValue}
            onChange={props.onChangeAfterStart}
          />
        </InputsGrid>
      </GroupContainer>

      <GroupContainer>
        <H4>{t("System.StampOut")}</H4>
        <InputsGrid>
          <NumberSettingInput
            label={t("System.BeforeEnd")}
            value={props.beforeEndValue}
            onChange={props.onChangeBeforeEnd}
          />
          <NumberSettingInput
            label={t("System.AfterEnd")}
            value={props.afterEndValue}
            onChange={props.onChangeAfterEnd}
          />
        </InputsGrid>
      </GroupContainer>
    </SettingsSection>
  );
};

const GroupContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const InputsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 20px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;
